import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider, TimeProvider } from "@itoresearch/design-system";
import { FlagsProvider } from "@itoresearch/flags/react";

// Design tokens + Tailwind utilities come entirely from the design system.
// To redesign the product, change the design system — not this app.
import "@itoresearch/design-system/styles.css";
// React Flow's stylesheet is a HOST responsibility: the terminal-renderer
// canvas package intentionally imports no CSS (see packages/terminal-renderer).
import "@xyflow/react/dist/style.css";

import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import { SessionProvider } from "./lib/session";
import { AppHotkeysProvider } from "./lib/hotkeys";
import { installGlobalErrorCapture, telemetry } from "./lib/telemetry";

// Observability: wired to Axiom when credentials exist, console-only otherwise.
telemetry.info("web app booting", {
  environment: telemetry.config.environment,
});
installGlobalErrorCapture();

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000 } },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <TimeProvider>
        <FlagsProvider>
          <AppHotkeysProvider>
            <QueryClientProvider client={queryClient}>
              <SessionProvider>
                <RouterProvider router={router} />
              </SessionProvider>
            </QueryClientProvider>
          </AppHotkeysProvider>
        </FlagsProvider>
      </TimeProvider>
    </ThemeProvider>
  </StrictMode>,
);
